import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";

import "../UI Component/Modal/Modal.css";
import {
  disableHelpButton,
  enableHelpButton,
} from "../common/DisableHelpButton/DisableHelpButton";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

var FontAwesome = require("react-fontawesome");

export default function ViewDetailsModal(props) {
  const [appointmentDetails, setAppointmentDetails] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.openView) {
      disableHelpButton();
      setLoading(true);
      fetchAppointmentDetails();
    }
    return () => {
      enableHelpButton();
    };
  }, [props.openView]);

  function fetchAppointmentDetails() {
    afterLoginApiAxios
      .post(
        "/doctor/get-appointment-details-by-id",
        { appointment_id: props.appointment_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        C2CConsole.log(response);
        if (response.data) {
          if (response.data.statusCode == "200") {
            setAppointmentDetails(response.data.appointment_details);
            setLoading(false);
          } else {
            C2CConsole.log(response);
            setLoading(false);
            // TODO: Error handling and logging
          }
        } else {
          setLoading(false);
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function renderAppointmentType(appointmentType) {
    switch (appointmentType) {
      case "in-clinic":
        return <span>In-Clinic</span>;
      case "online":
        return <span>Online</span>;
      default:
        return "";
    }
  }

  function renderConsultationType(appointmentType, consultationType) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (consultationType) {
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        // fix for 7043

        return <span>{appointmentDetails.procedure_name}</span>;
      //
      default:
        return "";
    }
  }

  return (
    <>
      {props.openView ? (
        <Modal show={props.openView} onHide={props.closeView}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Appointment Details</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 view-detail">
            {loading ? (
              <Spinner animation="border" variant="secondary" />
            ) : (
              <>
                <div className="row mb-4">
                  <div className="col-12 text-center">
                    <h4>
                      <span
                        aria-hidden="true"
                        className="fa fa-calendar mr-1 iconSmall"
                      ></span>
                      <br />
                      <span>
                        {moment(appointmentDetails.appointment_date).format(
                          "MMM DD, YYYY"
                        )}
                      </span>
                    </h4>
                    <h6>
                      {moment(
                        appointmentDetails.appointment_start_time,
                        "hh:mmZ"
                      ).format("hh:mm A")}
                    </h6>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6 text-right">
                    <span className="heading">Patient Name:</span>
                  </div>
                  <div className="col-6 text-left">
                    <span>{appointmentDetails.patient_name}</span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6 text-right">
                    <span className="heading">Date of Birth:</span>
                  </div>
                  <div className="col-6 text-left">
                    <span>
                      {moment(appointmentDetails.patient_dob).format(
                        "DD MMM YYYY"
                      )}
                    </span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6 text-right">
                    <span className="heading">Gender:</span>
                  </div>
                  <div className="col-6 text-left">
                    <span>{appointmentDetails.patient_gender}</span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6 text-right">
                    <span className="heading">Phone Number:</span>
                  </div>
                  <div className="col-6 text-left">
                    <span>{appointmentDetails.phone_no}</span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6 text-right">
                    <span className="heading">Purpose of Consultation:</span>
                  </div>
                  <div className="col-6 text-left">
                    <span>{appointmentDetails.purpose_of_appointment}</span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6 text-right">
                    <span className="heading">Consultation Type:</span>
                  </div>
                  <div className="col-6 text-left">
                    <p>
                      {renderAppointmentType(
                        appointmentDetails.appointment_type
                      )}
                    </p>
                    <p className="mt-0">
                      <small>
                        {renderConsultationType(
                          appointmentDetails.appointment_type,
                          appointmentDetails.consultation_type
                        )}
                      </small>
                    </p>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6 text-right">
                    <span className="heading">Payment Method:</span>
                  </div>
                  <div className="col-6 text-left">
                    <span>{appointmentDetails.payment_method}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6 text-right">
                    <span className="heading">Attachments:</span>
                  </div>
                  <div className="col-6 text-left">
                    {appointmentDetails.patient_prescription_url &&
                    (appointmentDetails.patient_prescription_url === "" ||
                      appointmentDetails.patient_prescription_url.length <=
                        0) ? (
                      <span>NA</span>
                    ) : (
                      <ul>
                        {appointmentDetails.patient_prescription_url
                          ? appointmentDetails.patient_prescription_url.map(
                              (appt, index) => (
                                <li className="m-0 p-0 mb-1" key={index}>
                                  <span>Medical Record {index + 1} </span>
                                  &nbsp;
                                  <a
                                    target="_blank"
                                    href={appt}
                                    className="btn btn-sm btn-info"
                                    rel="noreferrer"
                                  >
                                    Download
                                  </a>
                                </li>
                              )
                            )
                          : ""}
                      </ul>
                    )}
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="dark" onClick={props.closeView}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null}
    </>
  );
}
